(function () {
  function initCarousels() {
    document.querySelectorAll('.card-carousel').forEach(function (carousel) {
      if (carousel.dataset.carouselInitialised) return;
      carousel.dataset.carouselInitialised = 'true';

      var track = carousel.querySelector('[data-carousel-track]');
      var slides = carousel.querySelectorAll('[data-carousel-slide]');
      var totalSlides = slides.length;
      if (totalSlides <= 1) return;

      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      var dots = carousel.querySelectorAll('[data-carousel-dot-index]');

      var current = 0;

      /* ---- update arrows ---- */
      function updateArrows() {
        if (prevBtn) {
          if (current === 0) {
            prevBtn.classList.add('disabled');
            prevBtn.disabled = true;
          } else {
            prevBtn.classList.remove('disabled');
            prevBtn.disabled = false;
          }
        }
        
        if (nextBtn) {
          if (current === totalSlides - 1) {
            nextBtn.classList.add('disabled');
            nextBtn.disabled = true;
          } else {
            nextBtn.classList.remove('disabled');
            nextBtn.disabled = false;
          }
        }
      }

      /* ---- move to slide ---- */
      function goTo(index) {
        if (index < 0 || index >= totalSlides) return;

        current = index;
        track.style.transform = 'translateX(-' + (current * 100) + '%)';

        // Update dots
        dots.forEach(function (dot, i) {
          dot.classList.toggle('card-carousel__dot--active', i === current);
        });

        // Update slides active state
        slides.forEach(function (slide, i) {
          slide.classList.toggle('card-carousel__slide--active', i === current);
        });

        updateArrows();
      }

      /* ---- prev ---- */
      if (prevBtn) {
        prevBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (current > 0) {
            goTo(current - 1);
          }
        }, true);
      }

      /* ---- next ---- */
      if (nextBtn) {
        nextBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (current < totalSlides - 1) {
            goTo(current + 1);
          }
        }, true);
      }

      /* ---- dots ---- */
      dots.forEach(function (dot) {
        dot.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          goTo(parseInt(dot.dataset.carouselDotIndex, 10));
        }, true);
      });

      /* ---- swipe ---- */
      var touchStartX = 0;
      carousel.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].screenX;
      }, { passive: true });

      carousel.addEventListener('touchend', function (e) {
        var diff = touchStartX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 40) {
          if (diff > 0 && current < totalSlides - 1) {
            goTo(current + 1);
          } else if (diff < 0 && current > 0) {
            goTo(current - 1);
          }
        }
      }, { passive: true });

      /* ---- init ---- */
      goTo(0);
    });
  }

  // Initialize carousels when document is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCarousels);
  } else {
    initCarousels();
  }

  // Make the init function globally accessible
  window.initCardCarousels = initCarousels;
})();

(function () {
  const loaderResetTimeouts = new WeakMap();
  const FALLBACK_RESET_MS = 1800;

  function setProductAtcLoading(button, isLoading) {
    if (!button) return;

    if (isLoading) {
      button.classList.add('loading');
      button.setAttribute('aria-busy', 'true');
      button.setAttribute('aria-disabled', 'true');
      return;
    }

    button.classList.remove('loading');
    button.removeAttribute('aria-busy');
    button.removeAttribute('aria-disabled');
  }

  function clearPendingReset(button) {
    const timeoutId = loaderResetTimeouts.get(button);
    if (timeoutId) {
      clearTimeout(timeoutId);
      loaderResetTimeouts.delete(button);
    }
  }

  function scheduleFallbackReset(button) {
    clearPendingReset(button);
    const timeoutId = setTimeout(() => {
      setProductAtcLoading(button, false);
      loaderResetTimeouts.delete(button);
    }, FALLBACK_RESET_MS);
    loaderResetTimeouts.set(button, timeoutId);
  }

  function findButtonsByVariantId(variantId) {
    if (!variantId) return [];
    const normalizedVariantId = String(variantId);
    return Array.from(
      document.querySelectorAll(`button.custom_product_ATC[data-var-id="${normalizedVariantId}"]`)
    );
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('button.custom_product_ATC');
    if (!button) return;

    if (button.hasAttribute('disabled') || button.getAttribute('aria-disabled') === 'true') return;

    setProductAtcLoading(button, true);
    scheduleFallbackReset(button);
  });

  window.addEventListener('animeal:cart:request-start', (event) => {
    if (event?.detail?.source !== 'product-form') return;

    const matchedButtons = findButtonsByVariantId(event?.detail?.variantId);
    matchedButtons.forEach((button) => {
      clearPendingReset(button);
      setProductAtcLoading(button, true);
    });
  });

  window.addEventListener('animeal:cart:request-end', (event) => {
    if (event?.detail?.source !== 'product-form') return;

    const matchedButtons = findButtonsByVariantId(event?.detail?.variantId);
    if (!matchedButtons.length) {
      document.querySelectorAll('button.custom_product_ATC.loading').forEach((button) => {
        clearPendingReset(button);
        setProductAtcLoading(button, false);
      });
      return;
    }

    matchedButtons.forEach((button) => {
      clearPendingReset(button);
      setProductAtcLoading(button, false);
    });
  });
})();

   



(function () {
  function injectOrderCounts(root = document) {
    const items = root.querySelectorAll(
      '.product-card-additional-inner-main:not([data-filled="true"])'
    );

    items.forEach((el) => {
      el.dataset.filled = 'true';

      const random = Math.floor(Math.random() * (3000 - 500 + 1)) + 500;
      const formatted = random >= 1000 ? `${Math.floor(random / 1000)}K+` : random;

      el.innerHTML = `<span class="order-count">${formatted} bought in past month</span>`;
    });
  }

  function runInject() {
    injectOrderCounts(document);
  }

  document.addEventListener('DOMContentLoaded', runInject);
  window.addEventListener('load', runInject);

  const observer = new MutationObserver(function () {
    runInject();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(runInject, 500);
  setTimeout(runInject, 1500);
  setTimeout(runInject, 3000);
})();

(function () {
  // Product card "N more options" popup: lists every quantity pack /
  // connected product / variant as its own row with its own Add to
  // Cart form. Each row's Add to Cart button always just adds straight
  // to the cart — no in-popup quantity stepper. To add more of a pack
  // afterwards, the quantity is increased from the cart itself (which
  // steps by that product's pack size via custom-cart-quantity.js).

  function notifyCartChanged(cart) {
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart, source: 'cvp-popup' } }));
    document.dispatchEvent(new CustomEvent('cart:build', { detail: { cart: cart, source: 'cvp-popup' } }));
    window.dispatchEvent(new CustomEvent('animeal:cart:changed', { detail: { cart: cart } }));
    // Those events only refresh the cart icon count (custom-atc.js's
    // updateAllATCStates() now skips these rows). The cart drawer's own
    // markup is a separate section that only refreshCartDrawer() fetches
    // and re-renders — without this, the drawer keeps showing stale
    // contents (icon count updates, drawer doesn't) after a popup add.
    if (window.customATCManager && typeof window.customATCManager.refreshCartDrawer === 'function') {
      window.customATCManager.refreshCartDrawer(false);
    }
  }

  // Injects the same white-spinner markup the main product-card ATC
  // buttons use (see custom-atc.js), so this row button shows a plain
  // spinner while its request is in flight instead of a text swap.
  // Reuses window.customATCManager's engine — see
  // startCartAnimation/resolveCartAnimation/resetCartAnimation there.
  function ensureCvpRowAnimationMarkup(btn) {
    var label = btn.querySelector('span');
    if (label && label.classList) label.classList.add('atc-label-default');

    if (!btn.querySelector('.atc-spinner')) {
      var spinner = document.createElement('span');
      spinner.className = 'atc-spinner';
      spinner.setAttribute('aria-hidden', 'true');
      btn.appendChild(spinner);
    }
  }

  // Marks a single row's button as "Added" and keeps it that way (no
  // revert timeout) — the point is for the customer to still see which
  // option(s) they picked if they look back at the popup later.
  function markRowAdded(form) {
    var btn = form.querySelector('.cvp-row-atc');
    if (!btn) return;
    var span = btn.querySelector('span');
    if (span) span.textContent = 'Added';
    btn.classList.add('cvp-row-added');
  }

  function markRowNotAdded(form) {
    var btn = form.querySelector('.cvp-row-atc');
    if (!btn) return;
    var span = btn.querySelector('span');
    if (span) span.textContent = 'Add to Cart';
    btn.classList.remove('cvp-row-added');
  }

  // Pack-size rows all share ONE Shopify variant id (see custom__variant_popup.liquid —
  // no properties[Pack] any more, on purpose, so they merge into a single
  // cart line), so the cart itself can't tell which specific row(s) a
  // customer clicked. We remember that ourselves, per product, in
  // localStorage — keyed by each row form's own id — instead of marking
  // every sibling row that shares the variant as Added.
  var ADDED_ROWS_STORAGE_KEY = 'cvpAddedRows';

  // In-memory mirror is the real source of truth — it works for the rest
  // of this page's life even when localStorage is blocked/partitioned
  // (private browsing, the theme-editor preview iframe, etc.), which
  // otherwise silently loses the "which row was clicked" memory on every
  // popup reopen even though the very first add appeared to work.
  // localStorage is attempted only as a best-effort bonus so it also
  // survives a full page reload when the browser allows it.
  var addedRowsMemory = null;

  function getAddedRowsStore() {
    if (addedRowsMemory) return addedRowsMemory;
    try {
      addedRowsMemory = JSON.parse(localStorage.getItem(ADDED_ROWS_STORAGE_KEY)) || {};
    } catch (e) {
      addedRowsMemory = {};
    }
    return addedRowsMemory;
  }

  function persistAddedRowsStore(store) {
    addedRowsMemory = store;
    try {
      localStorage.setItem(ADDED_ROWS_STORAGE_KEY, JSON.stringify(store));
    } catch (e) {}
  }

  function rememberRowAdded(productId, rowKey) {
    if (!productId || !rowKey) return;
    var store = getAddedRowsStore();
    var rows = store[productId] || [];
    if (rows.indexOf(rowKey) === -1) rows.push(rowKey);
    store[productId] = rows;
    persistAddedRowsStore(store);
  }

  function addRowToCart(form, rxExtra) {
    var btn = form.querySelector('.cvp-row-atc');
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;

    var atcManager = window.customATCManager;

    // Prescription products: collect the prescription first. custom-atc.js
    // calls cvpAddRowToCart(form, extra) back once the popup is submitted.
    var rxOverlay = form.closest('[data-cvp-overlay]');
    if (
      !rxExtra &&
      rxOverlay && rxOverlay.getAttribute('data-rx-required') === 'true' &&
      (document.getElementById('upload-prescription') || (window.AnimealRx && window.AnimealRx.mount('upload-prescription'))) &&
      atcManager && typeof atcManager.openPrescriptionGateFor === 'function'
    ) {
      atcManager.openPrescriptionGateFor('cvprow', { form: form });
      return;
    }

    ensureCvpRowAnimationMarkup(btn);
    btn.setAttribute('aria-disabled', 'true');

    // Show the same white spinner the main product-card buttons use
    // instead of a plain "Adding..." text swap — it spins for as long as
    // this request is in flight, then clears once resolveCartAnimation()
    // below is called on success.
    if (atcManager) atcManager.startCartAnimation(btn);

    var overlay = form.closest('[data-cvp-overlay]');
    var productId = overlay ? overlay.getAttribute('data-product-id') : null;

    var rowFormData = new FormData(form);
    if (rxExtra) {
      if (rxExtra.file) {
        rowFormData.set('properties[Prescription]', rxExtra.file, rxExtra.file.name);
      } else if (rxExtra.mode) {
        rowFormData.set('properties[Prescription]', rxExtra.mode);
      }
      if (rxExtra.docName) rowFormData.set('properties[Doctor]', rxExtra.docName);
    }
    var rxDoctorId = null;
    try { rxDoctorId = localStorage.getItem('doctor_id'); } catch (e) {}
    if (rxDoctorId) rowFormData.set('properties[doctorId]', rxDoctorId);

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: rowFormData,
    })
      .then(function (r) { return r.json(); })
      .then(function (result) {
        btn.removeAttribute('aria-disabled');

        // Shopify can add fewer than requested (stock ran out mid-request)
        // and still respond with status 422 + "Only N items were added to
        // your cart due to availability." — that's a partial success, the
        // row really did get added, so don't revert its button text back
        // to "Add to Cart" as if nothing happened.
        var partialMessage = result.description || result.message || '';
        var partiallyAdded = result.status === 422 && /were added/i.test(partialMessage);

        if (result.status && !partiallyAdded) {
          if (atcManager) atcManager.resetCartAnimation(btn);
          return;
        }

        // Only THIS row gets marked Added — never its siblings, even
        // when they share the same variant id (pack-size rows).
        rememberRowAdded(productId, form.id);

        // Show "Added" only once the cart icon has actually finished
        // sliding out, not the instant the network request resolves.
        if (atcManager) {
          btn.addEventListener('atc-animation-complete', function () {
            atcManager.resetCartAnimation(btn);
            markRowAdded(form);
          }, { once: true });
          atcManager.resolveCartAnimation(btn);
        } else {
          markRowAdded(form);
        }

        return fetch('/cart.json', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) { notifyCartChanged(cart); });
      })
      .catch(function () {
        btn.removeAttribute('aria-disabled');
        if (atcManager) atcManager.resetCartAnimation(btn);
      });
  }

  // Every time the popup opens, sync each row against the real cart so a
  // pack added earlier (this visit or a previous one) still shows Added —
  // not just for the instant after clicking. A row is only shown as Added
  // when BOTH are true: its variant still has a quantity in the cart, and
  // this exact row (by its own form id) is the one that was clicked —
  // otherwise pack-size rows sharing one variant would all light up
  // together even though only one of them was actually added.
  function syncOverlayAddedState(overlay) {
    var productId = overlay.getAttribute('data-product-id');

    fetch('/cart.json', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var qtyByVariantId = {};
        cart.items.forEach(function (item) {
          qtyByVariantId[item.variant_id] = (qtyByVariantId[item.variant_id] || 0) + item.quantity;
        });

        var store = getAddedRowsStore();
        var rememberedRowIds = store[productId] || [];
        var stillPresentRowIds = [];

        overlay.querySelectorAll('.cvp-row-form form').forEach(function (f) {
          var idInput = f.querySelector('input[name="id"]');
          var qtyInput = f.querySelector('input[name="quantity"]');
          if (!idInput) return;
          var variantId = parseInt(idInput.value, 10);
          var rowQty = qtyInput ? parseInt(qtyInput.value, 10) : null;
          var cartQty = qtyByVariantId[variantId] || 0;
          var wasClicked = rememberedRowIds.indexOf(f.id) !== -1;

          // Two independent ways to recognize "this row is the one that's
          // in the cart": the localStorage memory of which row was
          // clicked (survives page navigation, but gets wiped by a
          // refresh whenever localStorage is blocked/partitioned - the
          // theme editor preview iframe does this), OR this row's own
          // fixed pack quantity exactly matching what's actually in the
          // cart for the shared variant (works even with no memory at
          // all, since a refresh re-fetches the real cart from Shopify).
          // Either one alone is enough; a refresh no longer drops back to
          // "Add to Cart" just because storage didn't survive it.
          var exactQtyMatch = rowQty !== null && cartQty === rowQty;

          if (exactQtyMatch || (cartQty > 0 && wasClicked)) {
            markRowAdded(f);
            stillPresentRowIds.push(f.id);
          } else {
            markRowNotAdded(f);
          }
        });

        // Drop any remembered row whose variant is no longer in the cart
        // at all (e.g. removed from the cart drawer/page), so it doesn't
        // come back as "Added" next time this popup opens.
        if (productId) {
          store[productId] = stillPresentRowIds;
          persistAddedRowsStore(store);
        }
      })
      .catch(function () {});
  }

  // <product-form> (assets/product-form.js) is a custom element that
  // ALWAYS binds its own native "submit" listener directly on the
  // <form>, independent of anything here — it would still fire its own
  // add-to-cart for these rows otherwise. Listening on the CAPTURE
  // phase runs this before that target-phase listener, so stopping
  // propagation here keeps it from ever firing (avoids a double add).
  window.cvpAddRowToCart = addRowToCart;

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.classList || !form.closest('.cvp-row-form')) return;
    event.preventDefault();
    event.stopPropagation();
    addRowToCart(form);
  }, true);

  var openOverlay = null;

  function openPopup(overlay) {
    if (!overlay) return;
    // Moved to document.body so position:fixed always covers the real
    // viewport — left inside the card, a hover/animation transform on
    // an ancestor can make "fixed" position relative to that ancestor
    // instead of the screen (only part of the screen dims).
    if (overlay.parentNode !== document.body) {
      document.body.appendChild(overlay);
    }
    overlay.removeAttribute('hidden');
    document.body.classList.add('cvp-open');
    openOverlay = overlay;
    syncOverlayAddedState(overlay);
  }

  function closePopup(overlay) {
    if (!overlay) return;
    overlay.setAttribute('hidden', '');
    document.body.classList.remove('cvp-open');
    if (openOverlay === overlay) openOverlay = null;
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-cvp-open]');
    if (opener) {
      // The card markup nests this button inside the card's own
      // "card-link-wrapper" <a href="product url">. Without this, the
      // click event still bubbles up into that anchor's native
      // navigate-on-click behavior — on mobile that navigation can
      // win the race against the popup opening, so the FIRST tap
      // silently sends you to the product page (popup never visibly
      // opens) and only a second attempt (after coming back) works.
      event.preventDefault();
      var overlay = document.getElementById(opener.getAttribute('data-cvp-open'));
      openPopup(overlay);
      return;
    }

    var closer = event.target.closest('[data-cvp-close]');
    if (closer) {
      closePopup(closer.closest('[data-cvp-overlay]'));
      return;
    }

    if (event.target.hasAttribute && event.target.hasAttribute('data-cvp-overlay')) {
      closePopup(event.target);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openOverlay) {
      closePopup(openOverlay);
    }
  });

  // Popup row: tapping anywhere on a row (image, name, price...) goes to
  // that row's own product page with its option pre-selected, EXCEPT the
  // Add to Cart form/button, which keeps adding-to-cart in place.
  document.addEventListener('click', function (event) {
    var row = event.target.closest('.cvp-row[data-cvp-nav-url]');
    if (!row) return;
    if (event.target.closest('.cvp-row-form')) return;
    var url = row.getAttribute('data-cvp-nav-url');
    if (url) window.location.href = url;
  });

  // Product card: clicking anywhere on the card (image, title, price,
  // badges, whitespace...) opens the product page, EXCEPT actual
  // interactive controls (Add to Cart, Enquire Now, wishlist heart,
  // carousel arrows/dots, variant popup, quantity stepper) which keep
  // their own behavior. Done via delegated click here — rather than
  // relying only on the card's own wrapping <a> — because that link
  // wraps buttons/forms/nested <a> tags (invalid HTML the browser can
  // reparent unpredictably), so this is the reliable fallback.
  var CARD_CLICK_IGNORE_SELECTOR = [
    'a',
    'button',
    'input',
    'select',
    'textarea',
    'label',
    '[data-cvp-open]',
    '[data-cvp-close]',
    '[data-cvp-overlay]',
    '.card-carousel__btn',
    '.card-carousel__dots',
    '.heart-svg',
    '.heart-svg-empty',
    '.ctts-variant-option',
    '.quick-add',
    '.custom-qty-selector-wrapper'
  ].join(', ');

  document.addEventListener('click', function (event) {
    var card = event.target.closest('.custom-card[data-card-url]');
    if (!card) return;
    if (event.target.closest(CARD_CLICK_IGNORE_SELECTOR)) return;

    var url = card.getAttribute('data-card-url');
    if (url) {
      window.location.href = url;
    }
  });
})();

/* Clicking the "Filter" pill toggles the whole pill filter bar
   (Sort by, Availability, Product type, etc.) hidden/shown, leaving
   only the "Filter" pill itself visible when collapsed. Delegated on
   document since facets re-render their markup via AJAX on every
   filter change. */
(function () {
  document.addEventListener('click', function (event) {
    var heading = event.target.closest('.facets-pill-style .facets__heading');
    if (!heading) return;

    var wrapper = heading.closest('.facets__wrapper');
    if (!wrapper) return;

    wrapper.classList.toggle('facets__wrapper--collapsed');
  });
})();









